import type { StatsSnapshot } from './gameplay-snapshot';
import { unitStats as stats } from './index';

export const updateGarrisonStats = (state: StatsSnapshot) => {
  const garrison = state.generators.garrison;

  const generatedWarriors = garrison.owned * garrison.baseGeneration;

  stats.garrison = {
    unitsGeneration: generatedWarriors,
  };
};
